import { customElement } from "lit/decorators.js";
import { CtxContentPreview } from "./ctx-content-preview";
import { markdownContentTemplate } from "src/modules/helpers/render-template-helpers";

@customElement('ctx-content-preview-template')
export class CtxContentPreviewTemplate extends CtxContentPreview {

    connectedCallback() {
      super.connectedCallback();
      this.template = this.defaultTemplate;
    }

    // todo add template-name and switch to load correct template renderer
    
    defaultTemplate = (htmlContent:string)=> markdownContentTemplate(htmlContent);
}